/** Иконки онбординг-сторис, которых нет в components/icons.tsx.
 *  Пути — из design_handoff_onboarding (assets/loyalty, assets/achievements,
 *  README §Иконки). Все line-иконки 24×24, currentColor. */

type P = { size?: number };

const base = (size: number) =>
  ({
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.9,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  }) as const;

/** Щит с галкой — экран «Достижения» (hero раздела). */
export function ShieldCheckIcon({ size = 20 }: P) {
  return (
    <svg {...base(size)} strokeWidth={1.8}>
      <path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z" />
      <path d="M9 11.5l2 2 4-4.5" />
    </svg>
  );
}

/** Билет со звездой — экран «Straddle Pass». */
export function TicketStarIcon({ size = 20 }: P) {
  return (
    <svg {...base(size)} strokeWidth={1.8}>
      <path d="M3 9V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 0 0 6v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-6z" />
      <path d="m12 8.6.9 1.84 2.03.3-1.47 1.43.35 2.03L12 13.24l-1.81.96.35-2.03-1.47-1.43 2.03-.3L12 8.6z" />
    </svg>
  );
}

/** Стрелка вверх (чип «+18» личного рейтинга). */
export function ArrowUpIcon({ size = 11 }: P) {
  return (
    <svg {...base(size)} strokeWidth={2.4}>
      <path d="M12 19V5M5 12l7-7 7 7" />
    </svg>
  );
}

/* --- Уровни лояльности (assets/loyalty/lvl_*.svg) --- */

export function LvlCheckIcon({ size = 16 }: P) {
  return (
    <svg {...base(size)}>
      <path d="M8.6 12.4V5.6a1.7 1.7 0 0 1 3.4 0v5.2M12 10.8V4.6a1.7 1.7 0 0 1 3.4 0v6.2M15.4 11.2V6.8a1.7 1.7 0 0 1 3.4 0v7.4c0 3.6-2.4 6.4-6 6.4-3.4 0-4.8-1.6-6.4-4l-2-3.2a1.7 1.7 0 0 1 2.8-1.8l1.4 2" />
    </svg>
  );
}

export function LvlCallIcon({ size = 16 }: P) {
  return (
    <svg {...base(size)}>
      <circle cx="12" cy="12" r="8.4" />
      <circle cx="12" cy="12" r="4" />
      <path d="M12 3.6v2.6M12 17.8v2.6M3.6 12h2.6M17.8 12h2.6" />
    </svg>
  );
}

export function LvlBetIcon({ size = 16 }: P) {
  return (
    <svg {...base(size)}>
      <ellipse cx="12" cy="6.6" rx="6.4" ry="2.4" />
      <ellipse cx="12" cy="12" rx="6.4" ry="2.4" />
      <ellipse cx="12" cy="17.4" rx="6.4" ry="2.4" />
    </svg>
  );
}

export function LvlRaiseIcon({ size = 16 }: P) {
  return (
    <svg {...base(size)}>
      <ellipse cx="8.4" cy="11.4" rx="5.4" ry="2.2" />
      <path d="M3 11.4v5c0 1.2 2.4 2.2 5.4 2.2s5.4-1 5.4-2.2v-5" />
      <path d="M18.8 19V6.2M15.6 9.4l3.2-3.2 3.2 3.2" />
    </svg>
  );
}

export function LvlStraddleIcon({ size = 16 }: P) {
  return (
    <svg {...base(size)}>
      <circle cx="9" cy="10.8" r="5.2" />
      <circle cx="15" cy="10.8" r="5.2" />
      <path d="M5.6 19.6h12.8" />
    </svg>
  );
}

export function LvlStraddlePlusIcon({ size = 16 }: P) {
  return (
    <svg {...base(size)}>
      <circle cx="9" cy="14" r="4.6" />
      <circle cx="15" cy="14" r="4.6" />
      <path d="M6 21h12" />
      <path d="m12 2.2 1.1 2.24 2.47.36-1.79 1.74.42 2.46L12 7.84 9.79 9l.42-2.46L8.42 4.8l2.47-.36L12 2.2z" />
    </svg>
  );
}

/* --- Ачивки демо-карточки «Очки за достижения» --- */

/** «Гриндер» (t02.svg). */
export function AchGrinderIcon({ size = 17 }: P) {
  return (
    <svg {...base(size)}>
      <circle cx="12" cy="12" r="3" />
      <circle cx="12" cy="12" r="7.1" />
      <path d="M12 1.7v3.2M12 19.1v3.2M22.3 12h-3.2M4.9 12H1.7M19.3 4.7l-2.3 2.3M7 17l-2.3 2.3M19.3 19.3 17 17M7 7 4.7 4.7" />
    </svg>
  );
}

/** «Свой человек» (c01.svg). */
export function AchHomeIcon({ size = 17 }: P) {
  return (
    <svg {...base(size)}>
      <path d="M3.6 10.4 12 3.8l8.4 6.6V20a.9.9 0 0 1-.9.9H4.5a.9.9 0 0 1-.9-.9v-9.6z" />
      <path d="M9.4 20.9v-6.2h5.2v6.2" />
    </svg>
  );
}

/** Мини-колода (как инлайн-колода в ProfileScreen). */
export function DeckMiniIcon({ size = 28 }: P) {
  return (
    <svg
      width={size}
      height={(size * 30) / 24}
      viewBox="0 0 24 30"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.9}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="18" height="24" rx="3.5" />
      <path d="M9 10h6" opacity=".6" />
    </svg>
  );
}
